/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webParseGetWebTomarkdownAsyncStatus } from "../../funcs/webParseGetWebTomarkdownAsyncStatus.js";
import { GetWebTomarkdownAsyncStatusRequest$zodSchema } from "../../models/getwebtomarkdownasyncstatusop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetWebTomarkdownAsyncStatusRequest$zodSchema,
};

export const tool$webParseGetWebTomarkdownAsyncStatus: ToolDefinition<
  typeof args
> = {
  name: "web-parse-get-web-tomarkdown-async-status",
  description: `转换任务状态

提交了网页转 Markdown 任务后，想知道处理进度和结果？用这个接口来查询。

## 功能概述
通过任务 ID 查询转换任务的当前状态、处理进度和最终结果。任务结果缓存 30 分钟，期间可重复查询。

## 任务状态

| 状态 | 说明 |
|------|------|
| \`pending\` | 等待处理 |
| \`processing\` | 处理中 |
| \`completed\` | 已完成，可获取结果 |
| \`failed\` | 失败 |
| \`timeout\` | 超时（超过 60 秒） |

> [!NOTE]
> 建议每 2-5 秒轮询一次，当状态为 \`completed\`、\`failed\` 或 \`timeout\` 时停止轮询。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await webParseGetWebTomarkdownAsyncStatus(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
